import { render, staticRenderFns } from "./SisViewDialog.vue?vue&type=template&id=7ece1f2c&scoped=true"
import script from "./SisViewDialog.vue?vue&type=script&lang=js"
export * from "./SisViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ece1f2c",
  null
  
)

export default component.exports